<template>
    <select2 :options="genderOptions" v-model="selectedGender" v-on:input="emitSelectedItem()"></select2>

</template>

<script>
  export default {
    props: ['value'],
    data() {
      return {
        genderOptions: [{
          id: '',
          text: '-- Please Select --'
        },
        {
          id: 'Male',
          text: 'Male'
        }, {
          id: 'Female',
          text: 'Female'
        }],
        selectedGender: this.value
      }
    },
    methods: {
      mounted() {
        console.log('Gender options component mounted.');
      },
      emitSelectedItem() {
        console.log('Gender changed');
        // We use nextTick because we have to wait for the value of the select2 to update
        this.$nextTick(function() {
          this.$emit('input', this.selectedGender);
        })
      },
    }
  }
</script>